import { Pipe, PipeTransform } from '@angular/core';
import { BookingItem } from '../../models/booking-item';

@Pipe({
  name: 'bookingItemName',
  standalone: true
})
export class BookingItemNamePipe implements PipeTransform {
  transform(
    bookingItem: BookingItem,
    shortVersion = false,
    excludeQuantity = false
  ): any {
    if (!bookingItem.product) {
      if (excludeQuantity) {
        return `${bookingItem.category?.name ?? 'Uncategorised'} (Category)`;
      } else {
        return `${bookingItem.quantity} x ${bookingItem.category?.name ?? 'Uncategorised'} (Category)`;
      }
    }
    if (!bookingItem.item) {
      if (excludeQuantity) {
        return `${bookingItem.product.name} (Product)`;
      } else {
        return `${bookingItem.quantity} x ${bookingItem.product.name} (Product)`;
      }
    }

    if (shortVersion) {
      if (excludeQuantity) {
        return `Item: ${bookingItem.item.code}`;
      } else {
        return `Item: ${bookingItem.quantity} x ${bookingItem.item.code}`;
      }
    }
    if (excludeQuantity) {
      return `Item: ${bookingItem.item.code} (${bookingItem.product.name})`;
    }
    return `Item: ${bookingItem.quantity} x ${bookingItem.item.code} (${bookingItem.product.name})`;
  }
}
